import historyTypes from './historyTypes'

export const getHistoryOffers = payload => ({
  type: historyTypes.GET_HISTORY,
  payload
})

export const getHistoryOffersSuccess = payload => ({
  type: historyTypes.GET_HISTORY_SUCCESS,
  payload
})

export const getHistoryOffersFailure = payload => ({
  type: historyTypes.GET_HISTORY_FAILURE,
  payload
})

export const clearHistoryOffers = () => ({
  type: historyTypes.CLEAR_HISTORY_OFFERS
})

export const setFilters = payload => ({
  type: historyTypes.SET_FILTERS,
  payload
})

export const searchByMovementNumber = payload => ({
  type: historyTypes.SEARCH_BY_MOVEMENT_NUMBER,
  payload
})

export const loadMore = payload => ({
  type: historyTypes.LOAD_MORE,
  payload
})
